/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function AppsAndScripts(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4802 0.931641C13.6244 0.960446 13.7585 1.03121 13.864 1.13672L18.03 5.30371C18.1706 5.44435 18.2498 5.63515 18.2498 5.83398V18.334C18.2494 18.722 17.9548 19.0416 17.5769 19.0801L17.4998 19.084H3.41675V17.584H16.7498V7.41699H12.4998C12.301 7.41691 12.1101 7.33784 11.9695 7.19727C11.8289 7.05669 11.7498 6.86579 11.7498 6.66699V2.41699H4.91675V7.41699H3.41675V1.66699L3.4314 1.51953C3.46026 1.37562 3.53119 1.24207 3.63648 1.13672C3.77713 0.996066 3.96784 0.916992 4.16675 0.916992H13.3337L13.4802 0.931641ZM5.2273 10L2.7273 12.5L5.2273 15L4.16675 16.0605L1.13648 13.0303C0.843586 12.7374 0.843586 12.2626 1.13648 11.9697L4.16675 8.93945L5.2273 10ZM10.53 11.9697C10.8229 12.2626 10.8229 12.7374 10.53 13.0303L7.49976 16.0605L6.43921 15L8.93921 12.5L6.43921 10L7.49976 8.93945L10.53 11.9697ZM13.2498 5.25L15.2498 5.91699H16.5232L13.2498 2.64355V5.25Z"
        fill="currentColor"
      />
    </svg>
  )
}

AppsAndScripts.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default AppsAndScripts
